import { useState, useCallback, useMemo, useRef } from 'react'
import { uniq, concat, castArray } from 'lodash-es'

const useDittoSelected = function ({
  tbData = [],
  onChangeSelected,
  selectedIds = [],
}) {
  const selectedIdsRef = useRef(selectedIds)
  selectedIdsRef.current = selectedIds

  const [isCheckedAll, setIsCheckedAll] = useState('off')
  const [selectedChanged, setSelectedChanged] = useState([])

  const toggleCheckAll = useCallback(
    (_check) => {
      const check = _check ? 'on' : 'off'
      setIsCheckedAll(check)
      if (check === 'off') {
        onChangeSelected([])
      } else {
        onChangeSelected('all')
      }
    },
    [tbData]
  )

  const toggleCheck = useCallback(
    (_ids, select) => {
      const ids = castArray(_ids)

      if (select) {
        onChangeSelected(uniq(concat(ids, selectedIdsRef.current)))
      } else {
        onChangeSelected(
          selectedIdsRef.current.filter((x) => ids.indexOf(x) < 0)
        )
      }
      setIsCheckedAll(selectedIdsRef.current.length > 0 ? 'half' : 'off')
      setSelectedChanged(new Date())
    },
    [tbData]
  )

  const maskedData = useMemo(() => {
    const data = tbData || []

    return isCheckedAll === 'on' && selectedIds.length > 0
      ? data.map((x) => {
          return { ...x, __selection__: true }
        })
      : data.map((x) => {
          return {
            ...x,

            __selection__: x && selectedIds.indexOf(x.objectId) > -1,
          }
        })
  }, [isCheckedAll, selectedChanged, tbData, selectedIds])

  return {
    isCheckedAll,
    toggleCheckAll,
    maskedData,
    toggleCheck,
  }
}

export default useDittoSelected
